import { toast, TypeOptions } from "react-toastify";

export type AlertProps = {
  type: TypeOptions;
  message: string;
  duration?: number;
};

export const alert = (props: AlertProps) => {
  const { type, message ,duration} = props;
  return toast(message, { type, position: "top-right",autoClose:duration ?? 6000 });
};
